import React, { useState } from 'react'
import { HelpCircle as HelpCircleIcon } from 'react-feather'
import { useHistory } from 'react-router-dom'
import { Box, Button, Grid } from '@material-ui/core'

import {
  Container,
  ContentHeader,
  Dai,
  DriveTour,
  FatButton,
  LoadingFeedback,
  Page,
} from 'components'
import { ServiceTypeDialog, ShowTicketDialog } from './components'

import useAuth from 'hooks/useAuth'
import usePermissions from 'hooks/usePermissions'

import DaiChatProvider from 'providers/DaiChatProvider'

import constants from 'constants/index'
import theme from 'theme'

const HelpCenterMain = () => {
  const [loading, setLoading] = useState(false)
  const [openTour, setOpenTour] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [openFaqDialog, setOpenFaqDialog] = useState(false)
  const [openTicketDialog, setOpenTicketDialog] = useState(false)

  const history = useHistory()
  const { company } = useAuth()
  const { permitted } = usePermissions()

  const {
    HELP_CENTER_OPTIONS,
    HELP_CENTER_FAQ_OPTIONS,
    HELP_CENTER_SOLICITATION_OPTIONS,
    HELP_CENTER_FINANCIAL_ID,
    HELP_CENTER_SOLICITATION_FINANCIAL_ID,
  } = constants.faqs

  const { TAGS } = constants.dai.solutions

  const defaultTicketChannel = company?.defaultTicketChannel

  const isPermittedFinancial = permitted(
    constants.permissions.PAYMENT_ORDERS.LIST,
  )

  const filteredOptions = HELP_CENTER_SOLICITATION_OPTIONS.filter((item) => {
    const isFinancial = item.id === HELP_CENTER_SOLICITATION_FINANCIAL_ID

    if (isFinancial && !isPermittedFinancial) return false

    return true
  })

  const filteredHelpCenterOptions = HELP_CENTER_OPTIONS.filter((item) => {
    const isFinancial = item.id === HELP_CENTER_FINANCIAL_ID

    if (isFinancial && (!isPermittedFinancial || !defaultTicketChannel))
      return false

    return true
  })

  const handleOpenTour = () => setOpenTour((prev) => !prev)
  const handleOpenDialog = () => setOpenDialog((prev) => !prev)
  const handleOpenFaqDialog = () => setOpenFaqDialog((prev) => !prev)
  const handleOpenTicketDialog = () => setOpenTicketDialog((prev) => !prev)

  const handleExternalTicket = () =>
    window.open(company?.externalTicketLink, '_blank')

  const handleRedirect = (id, route) => {
    const isRequestAssistance = id === 'requestAssistance'
    const isMyRequests = id === 'myRequests'

    if (!defaultTicketChannel && (isRequestAssistance || isMyRequests)) {
      return handleExternalTicket()
    }

    if (isRequestAssistance) return handleOpenDialog()
    if (isMyRequests) return handleOpenTicketDialog()
    if (id === 'faqs') return handleOpenFaqDialog()
    if (route) history.push(route)
  }

  return (
    <Page title="Central de atendimento">
      <Container maxWidth={false}>
        <ContentHeader title="Central de atendimento">
          <Button
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={handleOpenTour}
            id={constants.faqs.HELP_CENTER_MAIN_DRIVER_STEP_0}
            fullWidth
          >
            Tutorial
          </Button>
        </ContentHeader>
        <LoadingFeedback loading={loading} />
        <Box display="flex" flexDirection="column" gridGap={theme.spacing(4)}>
          <Dai.Permitted tag={TAGS.DAI_CHAT_PLATFORM}>
            <DaiChatProvider>
              <Dai.Chat chatSize="fixed" fixedHeight="52vh" variant="paper" />
            </DaiChatProvider>
          </Dai.Permitted>
          <Grid container spacing={4}>
            {filteredHelpCenterOptions?.map((item, index) => (
              <Grid key={index} item xs={12} sm={6} md={4}>
                <FatButton
                  onClick={() => handleRedirect(item.id, item.route())}
                  startIcon={<item.icon size={20} />}
                  selected={!!item?.selected}
                  fullWidth
                >
                  {item.title}
                </FatButton>
              </Grid>
            ))}
          </Grid>
        </Box>
        <ServiceTypeDialog
          open={openDialog}
          setOpen={setOpenDialog}
          title="Escolha o tipo de atendimento"
          items={filteredOptions}
          gridItemProps={{ xs: 12, md: 4 }}
        />
        <ServiceTypeDialog
          open={openFaqDialog}
          setOpen={setOpenFaqDialog}
          title="Escolha a categoria de FAQs"
          items={HELP_CENTER_FAQ_OPTIONS}
          gridItemProps={{ xs: 12, md: 6 }}
          dialogSize="md"
        />
        <ShowTicketDialog
          open={openTicketDialog}
          setOpen={setOpenTicketDialog}
          setLoading={setLoading}
        />
      </Container>
      <DriveTour
        stepsMatrix={constants.faqs.HELP_CENTER_MAIN_DRIVER_STEPS_OBJECT}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default HelpCenterMain
